import * as React from "react"
import { Flex, Text, Box } from "@chakra-ui/react"
import { ProductSelectLargeMenuProps } from "./types"
import { QuantitySelector } from "./quantity-selector"
import { ProductsOptions } from "./product-options"
import { ProductAmount } from "./product-amount"
import { useRecoilValue } from "recoil"
import {
  brandingSelector,
  productCheckoutPageSelector
} from "../../../../recoil/atoms/room"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"

const _ProductSelectLargeMenu: React.FC<ProductSelectLargeMenuProps> = ({
  optionsSelected,
  onChange,
  selectedQuantity,
  setSelectedQuantity,
  selectedVariant,
  setSelectedVariant,
  setOptionsSelected,
  handleUnselectProductOption,
  largeOptionsContainer,
  isLargeDropDown,
  isProductWithoutOptions
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  const isProductCheckoutPage = useRecoilValue(productCheckoutPageSelector)
  const { variants, productTitle, currencySymbol } = useRecoilValue(
    productOverlaySelector
  )

  const ProductAmoutProps = React.useMemo(() => {
    return {
      isSmallMainScreen: false,
      isBigBadge: false,
      isTransperent: false,
      currencySymbol,
      price: selectedVariant?.price,
      oldPrice: selectedVariant?.compare_at_price,
      quantity: selectedQuantity
    }
  }, [
    currencySymbol,
    selectedQuantity,
    selectedVariant?.compare_at_price,
    selectedVariant?.price
  ])

  const showQuantity = variants.length !== 0

  return (
    <Flex
      /* overflow="auto" */
      flexDirection="column"
      /* marginLeft="1rem" */
      /* height="100%" */
    >
      <Box display="grid">
        <Text
          fontSize="1.4rem"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          fontWeight="500"
          color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
          fontFamily={
            roomStyles?.badgeFontFamily && roomStyles?.badgeFontFamily
          }
        >
          {productTitle}
        </Text>
      </Box>

      {!isProductCheckoutPage && (
        <>
          {!isProductWithoutOptions && !isLargeDropDown && (
            <ProductsOptions
              largeOptionsContainer={largeOptionsContainer}
              optionsSelected={optionsSelected}
              onChange={onChange}
              handleUnselectProductOption={handleUnselectProductOption}
            />
          )}
          <Flex flexDirection="column" marginBottom={showQuantity && "0.5rem"}>
            {showQuantity && (
              <Text
                fontFamily={
                  roomStyles?.badgeFontFamily ?? "Assistant, sans-serif"
                }
                opacity={0.75}
                fontSize={"0.7rem"}
                marginTop="0.3rem"
                marginBottom="0.3rem"
                color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
              >
                {"Quantity"}
              </Text>
            )}
            <Flex>
              {showQuantity && (
                <Box ps="1">
                  <QuantitySelector
                    value={selectedQuantity}
                    onChange={setSelectedQuantity}
                    isSmallMainScreen={false}
                  />
                </Box>
              )}
              <Flex alignItems="center" marginLeft="2rem">
                <ProductAmount {...ProductAmoutProps} />
              </Flex>
            </Flex>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export const ProductSelectLargeMenu = React.memo(_ProductSelectLargeMenu)
